module.exports = __webpack_public_path__ + "static/media/facebook.a1795564.svg";